import React from "react";
import { Button, Stack } from "@mui/material";
import styled from "styled-components";
import { Link as RouteLink } from "react-router-dom";
import Link from "@mui/material/Link";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import { format } from "date-fns";

const H2 = styled.h2`
    font-size: 22px;
    font-weight: 500;
    margin: 0;
    color: ${({ theme }) => theme.palette.error.main};
`;

const Span = styled.span`
    font-size: 16px;
    font-weight: 300;
    opacity: 0.35;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const BorderedStack = styled(Stack)`
    border: ${({ theme }) => `3px dashed ${theme.palette.background.paper}`};
    border-radius: 14px;
    width: 100%;
`;

const BodyText = styled.p`
    font-size: 14px;
    font-weight: 300;
    margin: 0;
`;

const IntegratedNoData = ({ firstScrappedDate }) => {
    return (
        <BorderedStack
            spacing={2}
            direction="column"
            justifyContent="center"
            alignItems="center"
            p={10}
            m={3}
        >
            <PrecisionManufacturingIcon
                style={{ width: "100px", height: "auto", opacity: "0.3" }}
            />
            <Stack alignItems="center">
                <H2>Seems like our robots came back empty handed</H2>
                <Span style={{ marginBottom: "3rem" }}>
                    No data was found into your account{" "}
                    {firstScrappedDate &&
                        `since ${format(
                            new Date(firstScrappedDate * 1000 || firstScrappedDate),
                            "PPpp"
                        )}`}
                </Span>
                <BodyText>Feel free to review your integrated accounts.</BodyText>
                <BodyText style={{ marginBottom: "2rem" }}>
                    If you feel that this is a mistake please{" "}
                    <Link href="/upgrade/inquiry">contact us</Link> and we will investigate it as
                    soon as possible.
                </BodyText>
            </Stack>
            <Button
                variant="contained"
                component={RouteLink}
                to="/integrations"
                data-testid="dashboard-link"
            >
                Integrations
            </Button>
        </BorderedStack>
    );
};

export default IntegratedNoData;
